import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import './InvoicesPage.css';

const STATUS_OPTIONS = ['All', 'Draft', 'Sent', 'Paid'];

export default function InvoicesPage() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [filter, setFilter]     = useState('All');
  const [search, setSearch]     = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams();
    if (search)         params.set('search', search);
    if (filter !== 'All') params.set('status', filter);
    api.get(`/invoices?${params}`).then(data => { setInvoices(data); setLoading(false); });
  }, [search, filter]);

  const statusBadge = s => <span className={`badge badge-${s.toLowerCase()}`}>{s}</span>;

  return (
    <div className="invoices-page">
      <div className="page-header">
        <h2>Invoices</h2>
        <button className="btn-primary" onClick={() => navigate('/invoices/new')}>+ New Invoice</button>
      </div>

      <div className="toolbar">
        <input
          className="search-input"
          placeholder="Search client or description…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div className="status-tabs">
          {STATUS_OPTIONS.map(s => (
            <button
              key={s}
              className={`tab-btn ${filter === s ? 'active' : ''}`}
              onClick={() => setFilter(s)}
            >{s}</button>
          ))}
        </div>
      </div>

      {loading ? <div className="loading">Loading…</div> : invoices.length === 0 ? (
        <div className="empty-state">No invoices found.</div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Client</th>
              <th>Description</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Due</th>
              <th>Paid</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map(inv => (
              <tr key={inv.id} className="clickable-row" onClick={() => navigate(`/invoices/${inv.id}`)}>
                <td className="name-cell">{inv.clientName}{inv.company ? <span className="company"> · {inv.company}</span> : ''}</td>
                <td>{inv.description}</td>
                <td className="amount-cell">${Number(inv.amountDue).toFixed(2)}</td>
                <td>{statusBadge(inv.status)}</td>
                <td>{new Date(inv.dueDate).toLocaleDateString()}</td>
                <td>{inv.paidAt ? new Date(inv.paidAt).toLocaleDateString() : <span className="muted">—</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
